import PropTypes from "prop-types";
import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button";
import { CircleExclamationSolidV6 } from "@shared/v2/Icomoon";
import Loading from "../../../Goals/components/Loader";

const HandwrittenCardModal = ({ show, onHide, isLoading, iframeUrl, iframeRef, error, title }) => {
  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="tw-flex tw-items-center tw-justify-center tw-h-[80vh]">
          <Loading />
        </div>
      );
    }

    if (error) {
      return (
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-[300px] tw-gap-[16px] tw-p-[24px]">
          <CircleExclamationSolidV6 size="xxl" className="tw-text-semantic-red-100" />
          <div className="tw-text-center">
            <h3 className="tw-text-18d tw-font-semibold tw-text-gray-75 tw-mb-[8px]">Service Unavailable</h3>
            <p className="tw-text-14d tw-text-gray-50 tw-max-w-[400px]">{error}</p>
          </div>
          <Button schema="secondary" onClick={onHide}>
            Close
          </Button>
        </div>
      );
    }

    return (
      <iframe
        ref={iframeRef}
        src={iframeUrl}
        title={title}
        className="tw-w-full tw-h-[80vh] tw-border-none"
      />
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[90vw] tw-max-h-[90vh] tw-w-[1200px] tw-flex tw-flex-col"
    >
      <Modal.Header title={title} closeButton />
      <Modal.Body className="tw-p-0 tw-flex-1">{renderContent()}</Modal.Body>
    </Modal>
  );
};

HandwrittenCardModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  iframeUrl: PropTypes.string,
  iframeRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  error: PropTypes.string,
  title: PropTypes.string,
};

HandwrittenCardModal.defaultProps = {
  iframeUrl: null,
  iframeRef: null,
  error: null,
  title: "Send Handwritten Card",
};

export default HandwrittenCardModal;
